'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HighlightedJob;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _getTitleForLevel2 = require('shared/utils/getTitleForLevel');

var _getTitleForLevel3 = _interopRequireDefault(_getTitleForLevel2);

var _MatchTooltip = require('shared/components/MatchTooltip');

var _MatchTooltip2 = _interopRequireDefault(_MatchTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'highlighted-job slide';

var createEducation = function createEducation(__html) {
  return { __html: __html };
};

function HighlightedJob(_ref) {
  var image = _ref.image,
      imageAlt = _ref.imageAlt,
      title = _ref.title,
      salaryRange = _ref.salaryRange,
      educationRequirement = _ref.educationRequirement,
      careerLevel = _ref.careerLevel,
      fullSlug = _ref.fullSlug,
      match = _ref.match;

  var _getTitleForLevel = (0, _getTitleForLevel3.default)(careerLevel),
      level = _getTitleForLevel.title;

  return _react2.default.createElement(
    'article',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: 'job-image' },
      _react2.default.createElement('img', { src: image, alt: imageAlt })
    ),
    _react2.default.createElement(
      'div',
      { className: 'job-container' },
      _react2.default.createElement(
        'h3',
        null,
        fullSlug ? _react2.default.createElement(
          _reactRouter.Link,
          { to: fullSlug },
          title
        ) : title
      ),
      _react2.default.createElement(
        'p',
        null,
        salaryRange
      ),
      _react2.default.createElement('p', { dangerouslySetInnerHTML: createEducation(educationRequirement) }),
      _react2.default.createElement(
        'p',
        null,
        level,
        ' Position'
      ),
      _react2.default.createElement(_MatchTooltip2.default, {
        match: match,
        _class: 'c-tooltip',
        matchMeComponent: function matchMeComponent() {
          return _react2.default.createElement(
            'div',
            { className: 'no-match' },
            _react2.default.createElement(
              'span',
              null,
              'Match'
            ),
            _react2.default.createElement(
              'em',
              null,
              'me'
            )
          );
        },
        matchComponent: function matchComponent(parsedMatch) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'em',
              null,
              parsedMatch
            ),
            _react2.default.createElement(
              'span',
              null,
              'Match'
            )
          );
        }
      })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/HighlightedJobs/HighlightedJob.jsx
// module id = 1072
// module chunks = 0